import { render, staticRenderFns } from "./ServicoListFiltroModalItemInputCliente.vue?vue&type=template&id=2fcfb345"
import script from "./ServicoListFiltroModalItemInputCliente.vue?vue&type=script&lang=js"
export * from "./ServicoListFiltroModalItemInputCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports